import { render, staticRenderFns } from "./GameRules.vue?vue&type=template&id=5fe34184&scoped=true"
import script from "./GameRules.vue?vue&type=script&lang=js"
export * from "./GameRules.vue?vue&type=script&lang=js"
import style0 from "./GameRules.vue?vue&type=style&index=0&id=5fe34184&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe34184",
  null
  
)

export default component.exports